import { NEWS_PANEL_UPDATE } from 'client/redux/news/constants';
import * as actions from 'client/redux/news/actionCreators';

export const newsEditPanelUpdate = (id, fields) => dispatch => {
  return dispatch(actions.newsUpdate(NEWS_PANEL_UPDATE, id, fields));
};
